/**
 * ping-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor Smith <tdsmith@safetyweb.org>
 */

import { MessageTag } from "../message-tag";
import { Message } from "./message";
import { ReplyVerifyingMessage } from "./reply-message";

export class PingRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_PING;
  public static tag : MessageTag = MessageTag.REQ_PING;

  public expectsReply () : boolean
  {
    return true;
  }

  /**
   * Construct a new {@link PingRequest}.
   */
  constructor (public generateMetrics : boolean = false)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/general/ping-request.ts